export enum SocialMediaType {

    Google = "google",
    Facebook = "facebook",
    Apple = "apple"
}
